// LIBRERIE/IMPORTS
import { Helmet } from 'react-helmet';
import { useTranslation } from "react-i18next";
import * as he from 'he';

// HOOKS
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID, appConfig } from "../../config/appConfig";

// COMPONENTI
import SubHeaderHome from "../Header/subHeader/SubHeaderHome";
import PropertySearchField from "./Search";
import ServicesSection from "./ServicesSection";
import Vetrina1 from "./Vetrina1";
import Vetrina2 from "./Vetrina2";
import FooterBannerVendi from "./FooterBannerVendi";
import LocationSearch from "./LocationSearch";
import Presentation from "./Presentation";
import SocialPost from "./SocialPost";
import GoogleReviews from '../Reviews/GoogleReviews';
import HomeValuation from "./HomeValuation/HomeValuation";
// import MultiSedeSection from "./MultiSedeSection";
//import TipologySearchSection from "./TipologySearchSection";
import LastArticles from "./LastArticles";
//import NewsLetterSection from "./NewsLetterSection";
//import BannerVendi from "./BannerVendi";
//import ServicesSection2 from "./ServicesSection2";
import LastProperties from "./LastProperties";

interface Props {
    seo: boolean;
    vetrina2: boolean;
    pageType: string;
    filters: { [key: string]: string[] };
    showLocationSearch: boolean;
    showFooterBannerVendi: boolean;
    showPresentationSection: boolean;
    showSocialSection: boolean;
    showVetrina1: boolean;
}

const HomePage: React.FC<Props> = ({
    seo,
    vetrina2,
    pageType,
    showLocationSearch,
    showFooterBannerVendi,
    showPresentationSection,
    showSocialSection,
    showVetrina1
}) => {

    const { t } = useTranslation();
    const { agency } = useGetAgencyDetails(AGENCY_ID);

    // --- Lettura Flag Indipendenti dalla Configurazione ---
    const shouldShowInSubHeader = appConfig.ui.searchForm.showSearchInHomePageSubHeader;
    const shouldShowBelowIntro = appConfig.ui.searchForm.showSearchBelowHomePageIntro;
    const shouldShowSearchAndFiltersSection = appConfig.ui.homePage.showSearchAndFilters;
    const homeValuationConfig = appConfig.features.homeValuation;
    // --- Fine Lettura ---

    return (
        <>
            <Helmet>
                <title>{he.decode(`${agency?.agencyName}`) ?? t('common.loading')}</title>
            </Helmet>

            <SubHeaderHome
                isSeo={seo}
                showSearchForm={shouldShowInSubHeader}
            />

            {showPresentationSection && (
                <Presentation />
            )}

            {shouldShowSearchAndFiltersSection && pageType === 'home' &&
                <section id="search-box" className="space-ptb">
                    <div className="container-fluid w-special">
                        <div className="row">
                            <div className="col-12">
                                <h2 className="text-center" dangerouslySetInnerHTML={{ __html: t('homePage.searchForm.title') as string }} />
                                {shouldShowBelowIntro && <PropertySearchField searchData={{}} largeVersion={true} />}
                            </div>
                        </div>
                    </div>
                </section>
            }

            {/* Vetrina con immobili */}
            {vetrina2 && (
                <Vetrina2 agencyName={agency?.agencyName ?? ''} />
            )}

            <LastProperties />

            {/* Sezione Google Reviews */}
            {appConfig.features.googleReviews.enabled && (
                <section id="google-reviews-box" className="space-ptb bg-gray">
                    <div className="container-fluid">
                        <GoogleReviews />
                    </div>
                </section>
            )}

            {/* Banner Vendi
            <BannerVendi />
            */}

            {/* Anteprima servizi */}
            {appConfig.ui.homePage.showServices && (
                <ServicesSection />
            )}

            { /*Ricerca per tipologia 
            <TipologySearchSection />
            *}

            {/* NewsLetter Section 
            <NewsLetterSection />
            */}

            {/* Ultimi articoli del blog */}
            {appConfig.ui.homePage.showLastArticles && (
                <LastArticles />
            )}
            
            {/* Ricerca veloce con immagini */}
            {showLocationSearch && (
                <LocationSearch seo={seo} />
            )}

            {/* Ultimi aggiunti
            {<LastProperties />}
            */}

            {/* Seconda Anteprima servizi
            <ServicesSection2 />
            */}

            {/* Footer Banner Vendi */}
            {showFooterBannerVendi && <FooterBannerVendi />}

            {/* Vetrina con immobili */}
            {showVetrina1 && <Vetrina1 />}

            {homeValuationConfig.enabled && homeValuationConfig.displayMode === 'banner' && (
                <section className="space-ptb bg-light">
                    <div className="container">
                        <HomeValuation />
                    </div>
                </section>
            )}

            {/* Social section */}
            {showSocialSection && <SocialPost />}
        </>
    );
};

export default HomePage;